import { CosmosDb } from 'lib/cosmos/cosmosDb.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { toSha256Async } from './crypto-helper.js';
import { stringHelper } from './string-helper.class.js';

export class PdfHelper {
	async getPdfHashAsync(item: CosmosDb.ICosmosItem): Promise<string> {
		return (await toSha256Async(item.system.updated)).substring(0, 6); // no need to use full sha hash, just take first 6 chars
	}

	getPdfWorkoutOrDietPlanName(type: 'training_plan' | 'diet_plan', user: UserDb.IUserItem): string {
		const filename = `${type}_${user.fullName}`;
		return this.processPdfName(filename);
	}

	getPdfFilename(item: CosmosDb.ICosmosItem, prefix?: string): string {
		let filename: string = item.system.name;

		if (prefix) {
			filename = prefix + filename;
		}

		return this.processPdfName(filename);
	}

	private processPdfName(name: string): string {
		return stringHelper.replaceNonAlphanumericExceptUnderscore(name.replaceAll(' ', '_')).toLowerCase();
	}
}

export const pdfHelper = new PdfHelper();
